export default "__VITE_ASSET__CULokNNO__"